import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import { DashboardItemsQuery, DashboardItemsQueryVariables, Query } from '../../../../data-access/gql-types/graphql';
import { DASHBOARD } from '../../../../data-access/queries/dashboard';
import { useCacheStore } from '../../store/cache';
import { useGroupsStore } from '../../store/groups';
import { UserGroupsCollectionSegmentPick } from '../../types';

export const useUserGroups = () => {
  const { selectedInstallationId, skipLavvaFetch } = useInstallationContext();
  const { setGroups, setLoading } = useGroupsStore((s) => s);
  const groupsSkip = useCacheStore((s) => s.groupsSkip);
  const { data, loading } = useQuery<DashboardItemsQuery, DashboardItemsQueryVariables>(DASHBOARD, {
    variables: { id: selectedInstallationId },
    fetchPolicy: 'no-cache',
    skip: skipLavvaFetch || groupsSkip,
  });

  useEffect(() => {
    if (data?.userGroups) setGroups(data.userGroups as UserGroupsCollectionSegmentPick, true);
  }, [data?.userGroups]);

  useEffect(() => setLoading(loading), [loading]);
};
